import React, {Component} from 'react';
import './thankYouPage.css';
import {Button,  Container} from 'reactstrap';
import {Link} from 'react-router-dom';


class ThankYouPage extends Component {
    constructor(props){
        super(props);
        this.state ={
            // show: false,
        }
    }

    render(){
        return (
            <div className='typ-container d-flex align-items-center justify-content-center'>
                <Container className='bg-transparent d-flex align-items-center justify-content-center h-100'>
                    <div className='typ-text'>
                        <h1>Thank you! Your submission was received.</h1>
                        <p style={{fontWeight: '300'}} className='pt-5'>Thank you for your interest in Lighthouse! We have received your submission.
                            If you have any questions,
                            please free free to contact us {' '}
                            <Link to='/contact-us' className='rm-hyperlink-color'>
                                here. 
                            </Link>
                        </p>
                        <Link to='/' className='btn-link d-flex justify-content-center justify-content-md-end pt-5'>
                            <Button className='btn typ-btn'>Return Home</Button>
                        </Link>
                    </div>
                    
                    

                   
                </Container>
                
            </div>
        );
    }
    
}

// const ThankYou = (props) => {
//         return (
//             <div className='ty-container'>
//                 <h2 className='ty-message'>Thank You</h2>
//                 <Button className='btn' onClick={this.hideThankYou}>Close</Button>
//             </div>
//         );
// }

export default ThankYouPage;